// 서버 BundleConditionService 의 skuId 길이 상한(BundleConditionSku.SKU_ID_LENGTH)과 명단 개수 상한(MAX_SKU_COUNT · MAX_BARCODE_COUNT)
export const MAX_SKU_ID_LENGTH = 14
export const MAX_DIRECT_INPUT_COUNT = 10000
